export class FileUpload {
    id: any;
    fileName: any;
    fileUploadFor: any;
    base64Image: any;
  }